import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class Button extends Component {
	render() {
		const { text, href = null, number } = this.props
		return (
			<div className='button'>
				{href ? (
					<Link to={{ pathname: href, query: number }}>
						<button>{text}</button>
					</Link>
				) : (
					<button>{text}</button>
				)}
			</div>
		)
	}
}
